<style scoped>
.app-card {
  margin: 0 auto;
  padding-top: 1rem !important;
}

</style>

<template>
  <div>
    <v-row
      v-for="(category, idx) in items"
      :key="idx"
    >
      <v-col>
        <v-card>
          <v-card-text class="app-row d-flex child-flex">
            <v-row>
              <v-col
                class="pa-0"
                v-for="item in category"
                :key="item.label"
              >
                <v-card
                  flat
                  tile
                  max-width="200"
                  class="app-card"
                  :id="`home-app-${item.permission}`"
                  :href="item.link"
                  :disabled="user.permissions ? !user.permissions.includes(item.permission) : true"
                >
                  <v-img :src="item.src" />
                  <v-card-text class="text--primary pa-1 text-center">
                    {{ item.label }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import appsMixin from '@anchor/vue-assets/src/mixins/appsMixin';


export default {
  mixins: [appsMixin],
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>
